import React, { useEffect } from 'react';
import '../styles/App.css';

const Toast = ({ message, duration = 2000, onClose, type = 'info' }) => {
	useEffect(() => {
		if (!message) return;
		const t = setTimeout(() => {
			onClose && onClose();
		}, duration);
		return () => clearTimeout(t);
	}, [message, duration, onClose]);

	if (!message) return null;

	return (
		<div className={`toast ${type}`} role="status" aria-live="polite">
			{message}
		</div>
	);
};

export default Toast;
